import { faMars, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  cancelReservation,
  renewSubscription,
  subscriptions,
} from "../apiServices/apiServices";
import {
  CheckRounded,
  DiscountOutlined,
  DiscountRounded,
  PercentOutlined,
  PercentRounded,
} from "@mui/icons-material";
import ConfirmBookingModal from "./ConfirmBookingModal";
import { confirmToast } from "./ConfirmToast";
import { alertToast } from "./AlertToast";

function ItemSubscription({ subscription, subscriptionRenewed }) {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleRenew = () => {
    setOpenModal(false);
    renewSubscription1(subscription.id, false);
  };

  const renewSubscription1 = async (subscriptionId, deductCutoffFare) => {
    try {
      const response = await renewSubscription(
        subscriptionId,
        deductCutoffFare,
      );
      if (response && response.success) {
        const cutOffErrors = response.errors.filter(
          (error) => error.error_code === "5001",
        );
        if (cutOffErrors.length > 0) {
          let message = response.message;
          message +=
            "\n\n• Would you like to book your seat(s) now at the advance booking fare?";
          const confirmed = await confirmToast(message);
          if (confirmed) {
            await renewSubscription1(subscription.id, true);
          }
          return;
        } else {
          const confirmed = await alertToast(
            response.message || "Successfully renewed your subscription.",
          );

          if (confirmed) {
            subscriptionRenewed();
          }
        }
      } else {
        toast.error(response?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <div className="flex justify-center mb-4">
      <div className="w-full rounded-lg shadow-md">
        <div className="">
          <div className="p-2 bg-white rounded-l-lg">
            <div className="flex flex-row justify-between font-bold text-white bg-[#BE1F18] text-xs md:text-sm px-2 py-1 mt-2">
              <div>{subscription.title}</div>
              <div className="flex flex-row items-center space-x-1">
                {subscription.discount > 0 && (
                  <>
                    <PercentRounded size={160} />
                    <p>
                      {subscription.discount_type == "PERCENT"
                        ? "10% Off"
                        : `Rs. ${subscription.discount} Off`}
                    </p>
                  </>
                )}
              </div>
            </div>
            <p className="text-[#0e0e0e] text-xs md:text-sm mt-2">
              To qualify for the discount, please book 22 consecutive rides.
              Kindly note that cancellations are not allowed.
            </p>
            <p className="text-xs md:text-sm font-bold uppercase truncate mt-4">
              {subscription.route_name}
            </p>
            <div className="flex mt-2">
              {/* Right Column */}
              <div className="w-1/2 mt-0">
                <div className="mb-5">
                  <p className="text-xs md:text-sm">ORIGIN:</p>
                  <p className="text-xs md:text-sm font-bold uppercase truncate">
                    {subscription.pickup_stop_name}
                  </p>
                </div>
                <div className="mb-5">
                  <p className="text-xs md:text-sm mt-2">DESTINATION:</p>
                  <p className="text-xs md:text-sm font-bold uppercase truncate">
                    {subscription.dropoff_stop_name}
                  </p>
                </div>
              </div>
              <div className="w-1/2 mt-0">
                <div className="mb-5">
                  <p className="text-xs md:text-sm">SEAT NO:</p>
                  <p className="text-xs md:text-sm font-bold uppercase truncate">
                    {subscription.seat_no}
                  </p>
                </div>
                <div className="mb-5">
                  <p className="text-xs md:text-sm mt-2">EXPIRES:</p>
                  <p className="text-xs md:text-sm font-bold uppercase truncate">
                    {moment(subscription.expires_at).format("DD MMM YYYY")}
                  </p>
                </div>
              </div>
            </div>
            {subscription.is_renewed == 1 && (
              <div className="flex flex-row justify-center">
                <CheckRounded sx={{ color: "green" }} />
                <p className="ml-2 " style={{ color: "green" }}>
                  Renewed
                </p>
              </div>
            )}
            {subscription.is_renewed == 0 && subscription.is_expiring == 1 && (
              <button
                className="w-full mt-2 mb-2 px-2 py-2 border uppercase font-semibold border-[#BE1F18] text-[#BE1F18] hover:bg-[#BE1F18] hover:text-white text-xs rounded"
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Renew
              </button>
            )}
          </div>
        </div>
      </div>
      {openModal && (
        <ConfirmBookingModal
          open={openModal}
          title={`Transaction Confirmation`}
          description={
            <>
              Are you sure you want to renew this subscription?
              <br />
              The amount will be deducted from your wallet.
            </>
          }
          onCancel={() => setOpenModal(false)}
          onConfirm={() => handleRenew(subscription.id)}
        />
      )}
    </div>
  );
}

export default ItemSubscription;
